import { useEffect, useState } from 'react'

export const getOpacityClass = (className: string, opacity: number): string => {
  return `${className}/${opacity.toString()}`
}

const getOpacityFromOffset = (offset: number): string => {
  const weightedOffset = offset / 2
  if (weightedOffset > 100) {
    return 'bg-dark'
  }
  const opacityLevel = Math.floor(weightedOffset / 10) * 10

  return `bg-dark/${opacityLevel}`
}

export const useDynamicOpacityClass = (
  baseClass: string,
  baseOpacity: number
) => {
  const [opacityClass, setOpacityClass] = useState(
    getOpacityClass(baseClass, baseOpacity)
  )

  useEffect(() => {
    if (opacityClass === '') {
      setOpacityClass(getOpacityFromOffset(window.pageYOffset))
    }
    const onScroll = () => {
      setOpacityClass(getOpacityFromOffset(window.pageYOffset))
    }
    // clean up code
    window.addEventListener('scroll', onScroll, { passive: true })

    return () => window.removeEventListener('scroll', onScroll)
  }, [opacityClass])

  return { opacityClass }
}
